import React from "react";
import ApiCard from "../components/ApiCard";
export default function OnRequestCallback() {
    return (
        <ApiCard
            title="On Request Callback"
            description="Simulate ABDM Callback"
            url="abdm/on-request/"
            method="POST"
            payload={{
                type: "CONSENT_REQUEST",
                requestId: crypto.randomUUID()
            }}
            buttonText="Execute Callback"
        />
    );
}